import React, { useState, useEffect } from 'react';
import { CreditCard, Truck, Check, ArrowRight, ArrowLeft, User, Mail, Phone, MapPin, Globe, Building } from 'lucide-react';
import { useCart } from '../context/CartContext';
import emailjs from '@emailjs/browser';

emailjs.init("iplL6m5DP31rJowPD"); 

const Checkout = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    prenom: '',
    nom: '',
    email: '',
    telephone: '',
    adresse: '',
    ville: '',
    codePostal: '',
    pays: 'France',
  });
  const [paymentMethod, setPaymentMethod] = useState('');
  const [errors, setErrors] = useState({});
  const [isAnimating, setIsAnimating] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { clearCart, cartItems } = useCart();

  const isMobile = windowWidth <= 768;
  const isTablet = windowWidth > 768 && windowWidth <= 1024;

  const countries = [
    'Afghanistan', 'Afrique du Sud', 'Albanie', 'Algérie', 'Allemagne', 'Andorre', 'Angola', 'Antigua-et-Barbuda', 'Arabie Saoudite', 'Argentine',
    'Arménie', 'Australie', 'Autriche', 'Azerbaïdjan', 'Bahamas', 'Bahreïn', 'Bangladesh', 'Barbade', 'Belgique', 'Belize',
    'Bénin', 'Bhoutan', 'Biélorussie', 'Birmanie', 'Bolivie', 'Bosnie-Herzégovine', 'Botswana', 'Brésil', 'Brunei', 'Bulgarie',
    'Burkina Faso', 'Burundi', 'Cambodge', 'Cameroun', 'Canada', 'Cap-Vert', 'Chili', 'Chine', 'Chypre', 'Colombie',
    'Comores', 'Congo', 'Congo (RDC)', 'Corée du Nord', 'Corée du Sud', 'Costa Rica', 'Côte d\'Ivoire', 'Croatie', 'Cuba', 'Danemark',
    'Djibouti', 'Dominique', 'Égypte', 'Émirats Arabes Unis', 'Équateur', 'Érythrée', 'Espagne', 'Estonie', 'Eswatini', 'États-Unis',
    'Éthiopie', 'Fidji', 'Finlande', 'France', 'Gabon', 'Gambie', 'Géorgie', 'Ghana', 'Grèce', 'Grenade',
    'Guatemala', 'Guinée', 'Guinée-Bissau', 'Guinée Équatoriale', 'Guyana', 'Haïti', 'Honduras', 'Hongrie', 'Îles Marshall', 'Îles Salomon',
    'Inde', 'Indonésie', 'Irak', 'Iran', 'Irlande', 'Islande', 'Israël', 'Italie', 'Jamaïque', 'Japon',
    'Jordanie', 'Kazakhstan', 'Kenya', 'Kirghizistan', 'Kiribati', 'Koweït', 'Laos', 'Lesotho', 'Lettonie', 'Liban',
    'Liberia', 'Libye', 'Liechtenstein', 'Lituanie', 'Luxembourg', 'Macédoine du Nord', 'Madagascar', 'Malaisie', 'Malawi', 'Maldives',
    'Mali', 'Malte', 'Maroc', 'Maurice', 'Mauritanie', 'Mexique', 'Micronésie', 'Moldavie', 'Monaco', 'Mongolie',
    'Monténégro', 'Mozambique', 'Namibie', 'Nauru', 'Népal', 'Nicaragua', 'Niger', 'Nigeria', 'Norvège', 'Nouvelle-Zélande',
    'Oman', 'Ouganda', 'Ouzbékistan', 'Pakistan', 'Palaos', 'Palestine', 'Panama', 'Papouasie-Nouvelle-Guinée', 'Paraguay', 'Pays-Bas',
    'Pérou', 'Philippines', 'Pologne', 'Portugal', 'Qatar', 'République Centrafricaine', 'République Dominicaine', 'République Tchèque', 'Roumanie', 'Royaume-Uni',
    'Russie', 'Rwanda', 'Saint-Christophe-et-Niévès', 'Sainte-Lucie', 'Saint-Marin', 'Saint-Vincent-et-les-Grenadines', 'Salvador', 'Samoa', 'São Tomé-et-Príncipe', 'Sénégal',
    'Serbie', 'Seychelles', 'Sierra Leone', 'Singapour', 'Slovaquie', 'Slovénie', 'Somalie', 'Soudan', 'Soudan du Sud', 'Sri Lanka',
    'Suède', 'Suisse', 'Suriname', 'Syrie', 'Tadjikistan', 'Tanzanie', 'Tchad', 'Thaïlande', 'Timor Oriental', 'Togo',
    'Tonga', 'Trinité-et-Tobago', 'Tunisie', 'Turkménistan', 'Turquie', 'Tuvalu', 'Ukraine', 'Uruguay', 'Vanuatu', 'Vatican',
    'Venezuela', 'Viêt Nam', 'Yémen', 'Zambie', 'Zimbabwe'
  ];

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validateStep1 = () => {
    const newErrors = {};
    if (!formData.prenom.trim()) newErrors.prenom = 'Prénom requis';
    if (!formData.nom.trim()) newErrors.nom = 'Nom requis';
    if (!formData.email.trim() || !/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Email valide requis';
    if (!formData.telephone.trim()) newErrors.telephone = 'Téléphone requis';
    if (!formData.adresse.trim()) newErrors.adresse = 'Adresse requise';
    if (!formData.ville.trim()) newErrors.ville = 'Ville requise';
    if (!formData.codePostal.trim()) newErrors.codePostal = 'Code postal requis';
    if (!formData.pays.trim()) newErrors.pays = 'Pays requis';
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateStep2 = () => {
    if (!paymentMethod) {
      setErrors({ payment: 'Veuillez sélectionner un mode de paiement' });
      return false;
    }
    return true;
  };

  const sendOrderEmails = async (cartItems) => {
  const orderDate = new Date().toLocaleString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });

  
  // Formater les items du panier pour l'email
  const cartItemsHtml = (cartItems || []).map(item => {
    const name = item.name || item.nom || 'Article';
    const quantity = (item.cartQuantity ?? item.quantity) || 1;
    const price = (item.price ?? item.prix) || 0;
    const lineTotal = (price * quantity).toFixed(2);
    return `
    <div style="padding: 15px; border-bottom: 1px solid #e0e0e0;">
      <table role="presentation" style="width: 100%; border-collapse: collapse;">
        <tr>
          <td style="width: 60%; vertical-align: top;">
            <span style="color: #000000; font-weight: 700; font-size: 15px;">${name}</span>
          </td>
          <td style="width: 20%; text-align: center; vertical-align: top;">
            <span style="color: #666666; font-size: 14px;">Qté: ${quantity}</span>
          </td>
          <td style="width: 20%; text-align: right; vertical-align: top;">
            <span style="color: #c59b00; font-weight: 700; font-size: 15px;">${lineTotal} €</span>
          </td>
        </tr>
      </table>
    </div>
  `;
  }).join('');

  // Calculer le total
  const totalAmount = ((cartItems || []).reduce((sum, item) => {
    const quantity = (item.cartQuantity ?? item.quantity) || 1;
    const price = (item.price ?? item.prix) || 0;
    return sum + (price * quantity);
  }, 0)).toFixed(2);

  // Mapping des modes de paiement
  const paymentLabels = {
    virement: 'Virement bancaire',
    applepay: 'Apple Pay',
    wero: 'Wero',
  };

  // Paramètres communs pour les deux emails
  const templateParams = {
    order_date: orderDate,
    client_prenom: formData.prenom,
    client_nom: formData.nom,
    client_email: formData.email,
    client_telephone: formData.telephone,
    client_adresse: formData.adresse,
    client_ville: formData.ville,
    client_code_postal: formData.codePostal,
    client_pays: formData.pays,
    cart_items: cartItemsHtml,
    total_amount: totalAmount,
    mode_paiement: paymentLabels[paymentMethod],
  };

  try {
    // Envoi de l'email au client
    await emailjs.send(
      'service_23prn4k', // À remplacer par votre Service ID
      'template_ugdzh5y', // Template ID pour le client
      templateParams,
      'iplL6m5DP31rJowPD' // À remplacer par votre clé publique
    );

    // Envoi de l'email à l'admin
    await emailjs.send(
      'service_23prn4k', // À remplacer par votre Service ID
      'template_hcl5svt', // Template ID pour l'admin
      templateParams,
      'iplL6m5DP31rJowPD' // À remplacer par votre clé publique
    );

    console.log('Emails envoyés avec succès');
    return true;
  } catch (error) {
    console.error('Erreur lors de l\'envoi des emails:', error);
    console.error('Status:', error.status);
    console.error('Message:', error.message);
    console.error('Text:', error.text);
    return false;
  }
};

const handleNextStep = async () => {
  if (currentStep === 1 && !validateStep1()) return;
  if (currentStep === 2 && !validateStep2()) return;
  
  setIsAnimating(true);
  
  // Si on passe de l'étape 2 à l'étape 3, envoyer les emails
  if (currentStep === 2) {
    setIsLoading(true);
    const emailsSent = await sendOrderEmails(cartItems);
    setIsLoading(false);
    if (!emailsSent) {
      // Optionnel : gérer l'erreur d'envoi
      alert('Une erreur est survenue lors de l\'envoi de la confirmation. Veuillez nous contacter.');
    }
  }
  
  setTimeout(() => {
    setCurrentStep(prev => prev + 1);
    if (currentStep === 2) {
      clearCart();
    }
    setIsAnimating(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, 300);
};

  const handlePrevStep = () => {
    setIsAnimating(true);
    setTimeout(() => {
      setCurrentStep(prev => prev - 1);
      setIsAnimating(false);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 300);
  };

  const styles = {
    container: {
      width: '100%',
      minHeight: '100vh',
      background: '#f8f9fa',
      paddingBottom: '3rem',
    },
    hero: {
      background: 'linear-gradient(135deg, #000000 0%, #1a1a1a 100%)',
      padding: isMobile ? '2.5rem 1rem' : isTablet ? '3rem 2rem' : '4rem 2rem',
      color: '#ffffff',
      textAlign: 'center',
    },
    heroTitle: {
      fontSize: isMobile ? '1.8rem' : isTablet ? '2.5rem' : '3rem',
      fontWeight: '800',
      marginBottom: '1rem',
      fontFamily: "'Montserrat', sans-serif",
    },
    heroSubtitle: {
      fontSize: isMobile ? '0.95rem' : '1.2rem',
      color: '#cccccc',
    },
    progressBar: {
      maxWidth: '800px',
      margin: '2rem auto',
      padding: isMobile ? '0 1rem' : '0 2rem',
    },
    progressSteps: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      position: 'relative',
      marginBottom: '1rem',
    },
    progressLine: {
      position: 'absolute',
      top: '50%',
      left: '0',
      right: '0',
      height: '3px',
      background: '#e0e0e0',
      zIndex: 0,
      transform: 'translateY(-50%)',
    },
    progressLineFilled: {
      position: 'absolute',
      top: '50%',
      left: '0',
      height: '3px',
      background: 'linear-gradient(90deg, #c59b00 0%, #d4a800 100%)',
      zIndex: 1,
      transform: 'translateY(-50%)',
      transition: 'width 0.5s ease',
    },
    progressStep: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      zIndex: 2,
      background: '#f8f9fa',
      padding: '0 0.5rem',
    },
    progressCircle: {
      width: isMobile ? '40px' : '50px',
      height: isMobile ? '40px' : '50px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: '700',
      fontSize: isMobile ? '0.9rem' : '1rem',
      marginBottom: '0.5rem',
      transition: 'all 0.3s ease',
      border: '3px solid',
    },
    progressLabel: {
      fontSize: isMobile ? '0.7rem' : '0.85rem',
      fontWeight: '600',
      textAlign: 'center',
      transition: 'color 0.3s ease',
    },
    mainContent: {
      maxWidth: '900px',
      margin: '0 auto',
      padding: isMobile ? '1.5rem 1rem' : isTablet ? '2rem 1.5rem' : '3rem 2rem',
    },
    card: {
      background: '#ffffff',
      borderRadius: isMobile ? '15px' : '20px',
      padding: isMobile ? '1.5rem' : '2.5rem',
      boxShadow: '0 5px 20px rgba(0,0,0,0.08)',
      transition: 'all 0.3s ease',
      opacity: isAnimating ? 0 : 1,
      transform: isAnimating ? 'translateY(20px)' : 'translateY(0)',
    },
    cardTitle: {
      fontSize: isMobile ? '1.5rem' : '1.8rem',
      fontWeight: '700',
      color: '#000000',
      marginBottom: '2rem',
      display: 'flex',
      alignItems: 'center',
      gap: '0.8rem',
    },
    formGrid: {
      display: 'grid',
      gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
      gap: '1.5rem',
      marginBottom: '2rem',
    },
    formGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem',
    },
    formGroupFull: {
      gridColumn: isMobile ? '1' : '1 / -1',
    },
    label: {
      fontSize: '0.95rem',
      fontWeight: '600',
      color: '#000000',
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
    },
    input: {
      padding: '1rem',
      borderRadius: '10px',
      border: '2px solid #e0e0e0',
      fontSize: '1rem',
      transition: 'all 0.3s ease',
      fontFamily: 'inherit',
    },
    inputError: {
      borderColor: '#ff4444',
    },
    select: {
      padding: '1rem',
      borderRadius: '10px',
      border: '2px solid #e0e0e0',
      fontSize: '1rem',
      transition: 'all 0.3s ease',
      fontFamily: 'inherit',
      background: '#ffffff',
      cursor: 'pointer',
      appearance: 'none',
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23000000' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'right 1rem center',
      paddingRight: '2.5rem',
    },
    errorText: {
      color: '#ff4444',
      fontSize: '0.85rem',
      marginTop: '0.3rem',
    },
    paymentOptions: {
      display: 'grid',
      gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
      gap: '1rem',
      marginBottom: '2rem',
    },
    paymentOption: {
      padding: '1.5rem',
      borderRadius: '15px',
      border: '3px solid #e0e0e0',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '0.8rem',
      background: '#ffffff',
    },
    paymentOptionSelected: {
      borderColor: '#c59b00',
      background: '#fffdf5',
      transform: 'scale(1.02)',
    },
    paymentIcon: {
      fontSize: '2rem',
      fontWeight: '700',
    },
    paymentLabel: {
      fontSize: '1rem',
      fontWeight: '600',
      color: '#000000',
    },
    confirmationSection: {
      display: 'flex',
      flexDirection: 'column',
      gap: '2rem',
    },
    infoCard: {
      background: '#f8f9fa',
      borderRadius: '15px',
      padding: isMobile ? '1.5rem' : '2rem',
      border: '2px solid #e0e0e0',
    },
    infoTitle: {
      fontSize: '1.2rem',
      fontWeight: '700',
      color: '#000000',
      marginBottom: '1rem',
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
    },
    infoRow: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '0.8rem 0',
      borderBottom: '1px solid #e0e0e0',
    },
    infoLabel: {
      color: '#666666',
      fontWeight: '500',
    },
    infoValue: {
      color: '#000000',
      fontWeight: '600',
      textAlign: 'right',
    },
    alertBox: {
      background: 'linear-gradient(135deg, #c59b00 0%, #d4a800 100%)',
      color: '#ffffff',
      padding: isMobile ? '1.5rem' : '2rem',
      borderRadius: '15px',
      display: 'flex',
      alignItems: 'flex-start',
      gap: '1rem',
      boxShadow: '0 5px 20px rgba(197,155,0,0.3)',
    },
    alertIcon: {
      flexShrink: 0,
      marginTop: '0.2rem',
    },
    alertContent: {
      flex: 1,
    },
    alertTitle: {
      fontSize: isMobile ? '1.1rem' : '1.3rem',
      fontWeight: '700',
      marginBottom: '0.8rem',
    },
    alertText: {
      fontSize: isMobile ? '0.95rem' : '1rem',
      lineHeight: '1.6',
      opacity: 0.95,
    },
    loadingOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.7)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      gap: '1.5rem',
    },
    spinner: {
      width: '60px',
      height: '60px',
      border: '4px solid rgba(197, 155, 0, 0.2)',
      borderTop: '4px solid #c59b00',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite',
    },
    loadingText: {
      color: '#ffffff',
      fontSize: isMobile ? '1.1rem' : '1.3rem',
      fontWeight: '600',
      textAlign: 'center',
      padding: '0 2rem',
    },
    buttonsContainer: {
      display: 'flex',
      gap: '1rem',
      marginTop: '2rem',
      flexDirection: isMobile ? 'column' : 'row',
    },
    button: {
      flex: 1,
      padding: '1.2rem',
      borderRadius: '12px',
      fontSize: '1rem',
      fontWeight: '700',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      border: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '0.5rem',
    },
    buttonPrimary: {
      background: 'linear-gradient(135deg, #000000 0%, #1a1a1a 100%)',
      color: '#ffffff',
    },
    buttonSecondary: {
      background: 'transparent',
      color: '#666666',
      border: '2px solid #e0e0e0',
    },
  };

  const getProgressWidth = () => {
    if (currentStep === 1) return '0%';
    if (currentStep === 2) return '50%';
    return '100%';
  };

  const Button = ({ children, onClick, isPrimary, icon: Icon, disabled }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
      <button
        style={{
          ...styles.button,
          ...(isPrimary ? styles.buttonPrimary : styles.buttonSecondary),
          background: isPrimary && isHovered
            ? 'linear-gradient(135deg, #c59b00 0%, #d4a800 100%)'
            : isPrimary
            ? 'linear-gradient(135deg, #000000 0%, #1a1a1a 100%)'
            : isHovered
            ? '#f8f9fa'
            : 'transparent',
          transform: isHovered ? 'translateY(-2px)' : 'translateY(0)',
          boxShadow: isHovered ? '0 5px 15px rgba(0,0,0,0.2)' : 'none',
          opacity: disabled ? 0.5 : 1,
          cursor: disabled ? 'not-allowed' : 'pointer',
        }}
        onMouseEnter={() => !disabled && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={onClick}
        disabled={disabled}
      >
        {children}
        {Icon && <Icon size={20} />}
      </button>
    );
  };

  const renderStep1 = () => (
    <div style={styles.card}>
      <h2 style={styles.cardTitle}>
        <Truck size={28} color="#c59b00" />
        Informations de livraison
      </h2>

      <div style={styles.formGrid}>
        <div style={styles.formGroup}>
          <label style={styles.label}>
            <User size={16} />
            Prénom *
          </label>
          <input
            type="text"
            name="prenom"
            value={formData.prenom}
            onChange={handleInputChange}
            style={{
              ...styles.input,
              ...(errors.prenom ? styles.inputError : {}),
            }}
            placeholder="Votre prénom"
          />
          {errors.prenom && <span style={styles.errorText}>{errors.prenom}</span>}
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>
            <User size={16} />
            Nom *
          </label>
          <input
            type="text"
            name="nom"
            value={formData.nom}
            onChange={handleInputChange}
            style={{
              ...styles.input,
              ...(errors.nom ? styles.inputError : {}),
            }}
            placeholder="Votre nom"
          />
          {errors.nom && <span style={styles.errorText}>{errors.nom}</span>}
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>
            <Mail size={16} />
            Email *
          </label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            style={{
              ...styles.input,
              ...(errors.email ? styles.inputError : {}),
            }}
            placeholder="votre@email.com"
          />
          {errors.email && <span style={styles.errorText}>{errors.email}</span>}
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>
            <Phone size={16} />
            Téléphone *
          </label>
          <input
            type="tel"
            name="telephone"
            value={formData.telephone}
            onChange={handleInputChange}
            style={{
              ...styles.input,
              ...(errors.telephone ? styles.inputError : {}),
            }}
            placeholder="+33 6 12 34 56 78"
          />
          {errors.telephone && <span style={styles.errorText}>{errors.telephone}</span>}
        </div>

        <div style={{ ...styles.formGroup, ...styles.formGroupFull }}>
          <label style={styles.label}>
            <MapPin size={16} />
            Adresse *
          </label>
          <input
            type="text"
            name="adresse"
            value={formData.adresse}
            onChange={handleInputChange}
            style={{
              ...styles.input,
              ...(errors.adresse ? styles.inputError : {}),
            }}
            placeholder="Numéro et nom de rue"
          />
          {errors.adresse && <span style={styles.errorText}>{errors.adresse}</span>}
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>
            <Building size={16} />
            Ville *
          </label>
          <input
            type="text"
            name="ville"
            value={formData.ville}
            onChange={handleInputChange}
            style={{
              ...styles.input,
              ...(errors.ville ? styles.inputError : {}),
            }}
            placeholder="Votre ville"
          />
          {errors.ville && <span style={styles.errorText}>{errors.ville}</span>}
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>
            <MapPin size={16} />
            Code postal *
          </label>
          <input
            type="text"
            name="codePostal"
            value={formData.codePostal}
            onChange={handleInputChange}
            style={{
              ...styles.input,
              ...(errors.codePostal ? styles.inputError : {}),
            }}
            placeholder="75001"
          />
          {errors.codePostal && <span style={styles.errorText}>{errors.codePostal}</span>}
        </div>

        <div style={{ ...styles.formGroup, ...styles.formGroupFull }}>
          <label style={styles.label}>
            <Globe size={16} />
            Pays *
          </label>
          <select
            name="pays"
            value={formData.pays}
            onChange={handleInputChange}
            style={{
              ...styles.select,
              ...(errors.pays ? styles.inputError : {}),
            }}
          >
            <option value="">Sélectionnez un pays</option>
            {countries.map((country) => (
              <option key={country} value={country}>
                {country}
              </option>
            ))}
          </select>
          {errors.pays && <span style={styles.errorText}>{errors.pays}</span>}
        </div>
      </div>

      <div style={styles.buttonsContainer}>
        <Button onClick={handleNextStep} isPrimary icon={ArrowRight}>
          Continuer vers le paiement
        </Button>
      </div>
    </div>
  );

  const renderStep2 = () => (
    <div style={styles.card}>
      <h2 style={styles.cardTitle}>
        <CreditCard size={28} color="#c59b00" />
        Mode de paiement
      </h2>

      <div style={styles.paymentOptions}>
        <div
          style={{
            ...styles.paymentOption,
            ...(paymentMethod === 'virement' ? styles.paymentOptionSelected : {}),
          }}
          onClick={() => {
            setPaymentMethod('virement');
            setErrors({});
          }}
        >
          <img src="/CB.png" alt="CB" style={{ width: 48, height: 32, objectFit: 'contain' }} />
          <div style={styles.paymentLabel}>Virement bancaire</div>
        </div>

        <div
          style={{
            ...styles.paymentOption,
            ...(paymentMethod === 'applepay' ? styles.paymentOptionSelected : {}),
          }}
          onClick={() => {
            setPaymentMethod('applepay');
            setErrors({});
          }}
        >
          <img src="/Apple-Pay.png" alt="Apple Pay" style={{ width: 48, height: 32, objectFit: 'contain' }} />
          <div style={styles.paymentLabel}>Apple Pay</div>
        </div>

        <div
          style={{
            ...styles.paymentOption,
            ...(paymentMethod === 'wero' ? styles.paymentOptionSelected : {}),
          }}
          onClick={() => {
            setPaymentMethod('wero');
            setErrors({});
          }}
        >
          <img src="/wero.png" alt="Wero" style={{ width: 48, height: 32, objectFit: 'contain' }} />
          <div style={styles.paymentLabel}>Wero</div>
        </div>
      </div>

      {errors.payment && (
        <div style={{ ...styles.errorText, textAlign: 'center', marginBottom: '1rem' }}>
          {errors.payment}
        </div>
      )}

      <div style={styles.buttonsContainer}>
        <Button onClick={handlePrevStep} icon={ArrowLeft}>
          Retour
        </Button>
        <Button onClick={handleNextStep} isPrimary icon={ArrowRight}>
          Confirmer
        </Button>
      </div>
    </div>
  );

  const renderStep3 = () => {
    const paymentLabels = {
      virement: 'Virement bancaire',
      applepay: 'Apple Pay',
      wero: 'Wero',
    };

    return (
      <div style={styles.card}>
        <h2 style={styles.cardTitle}>
          <Check size={28} color="#c59b00" />
          Confirmation de commande
        </h2>

        <div style={styles.confirmationSection}>
          <div style={styles.alertBox}>
            <div style={styles.alertIcon}>
              <Mail size={28} />
            </div>
            <div style={styles.alertContent}>
              <div style={styles.alertTitle}>Commande confirmée !</div>
              <div style={styles.alertText}>
                Merci pour votre commande ! Un agent de DestockMax va vous contacter par email dans les plus brefs délais pour finaliser le paiement et confirmer les détails de livraison.
              </div>
            </div>
          </div>

          <div style={styles.infoCard}>
            <div style={styles.infoTitle}>
              <Truck size={20} color="#c59b00" />
              Informations de livraison
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Nom complet</span>
              <span style={styles.infoValue}>{formData.prenom} {formData.nom}</span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Email</span>
              <span style={styles.infoValue}>{formData.email}</span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Téléphone</span>
              <span style={styles.infoValue}>{formData.telephone}</span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Adresse</span>
              <span style={styles.infoValue}>{formData.adresse}</span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Ville</span>
              <span style={styles.infoValue}>{formData.ville} {formData.codePostal}</span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Pays</span>
              <span style={styles.infoValue}>{formData.pays}</span>
            </div>
          </div>

          <div style={styles.infoCard}>
            <div style={styles.infoTitle}>
              <CreditCard size={20} color="#c59b00" />
              Mode de paiement
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Méthode sélectionnée</span>
              <span style={styles.infoValue}>{paymentLabels[paymentMethod]}</span>
            </div>
          </div>
        </div>

        <div style={styles.buttonsContainer}>
          <Button onClick={() => window.location.href = '/'} isPrimary>
            Retour à l'accueil
          </Button>
        </div>
      </div>
    );
  };

  return (
    <div style={styles.container}>
      {isLoading && (
        <>
          <style>
            {`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}
          </style>
          <div style={styles.loadingOverlay}>
            <div style={styles.spinner}></div>
            <div style={styles.loadingText}>
              Envoi de votre commande en cours...
            </div>
          </div>
        </>
      )}
      
      <div style={styles.hero}>
        <h1 style={styles.heroTitle}>Finaliser ma commande</h1>
        <p style={styles.heroSubtitle}>
          Dernière étape avant de recevoir vos produits
        </p>
      </div>

      <div style={styles.progressBar}>
        <div style={styles.progressSteps}>
          <div style={styles.progressLine} />
          <div style={{ ...styles.progressLineFilled, width: getProgressWidth() }} />
          
          <div style={styles.progressStep}>
            <div
              style={{
                ...styles.progressCircle,
                background: currentStep >= 1 ? '#c59b00' : '#ffffff',
                color: currentStep >= 1 ? '#ffffff' : '#666666',
                borderColor: currentStep >= 1 ? '#c59b00' : '#e0e0e0',
              }}
            >
              {currentStep > 1 ? <Check size={20} /> : '1'}
            </div>
            <span
              style={{
                ...styles.progressLabel,
                color: currentStep >= 1 ? '#000000' : '#999999',
              }}
            >
              Livraison
            </span>
          </div>

          <div style={styles.progressStep}>
            <div
              style={{
                ...styles.progressCircle,
                background: currentStep >= 2 ? '#c59b00' : '#ffffff',
                color: currentStep >= 2 ? '#ffffff' : '#666666',
                borderColor: currentStep >= 2 ? '#c59b00' : '#e0e0e0',
              }}
            >
              {currentStep > 2 ? <Check size={20} /> : '2'}
            </div>
            <span
              style={{
                ...styles.progressLabel,
                color: currentStep >= 2 ? '#000000' : '#999999',
              }}
            >
              Paiement
            </span>
          </div>

          <div style={styles.progressStep}>
            <div
              style={{
                ...styles.progressCircle,
                background: currentStep >= 3 ? '#c59b00' : '#ffffff',
                color: currentStep >= 3 ? '#ffffff' : '#666666',
                borderColor: currentStep >= 3 ? '#c59b00' : '#e0e0e0',
              }}
            >
              {currentStep > 3 ? <Check size={20} /> : '3'}
            </div>
            <span
              style={{
                ...styles.progressLabel,
                color: currentStep >= 3 ? '#000000' : '#999999',
              }}
            >
              Confirmation
            </span>
          </div>
        </div>
      </div>

      <div style={styles.mainContent}>
        {currentStep === 1 && renderStep1()}
        {currentStep === 2 && renderStep2()}
        {currentStep === 3 && renderStep3()}
      </div>
    </div>
  );
};

export default Checkout;